import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class MeasurementAndTraceability extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'measurementAndTraceability'}
            title={'PROCEDURE P3.0 MEASUREMENT AND TRACEABILITY'}
            exportTitle={'<h2>Procedure P3.0 Measurement and Traceability</h2>'}
            exportFileName={'measurement_and_traceability.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (MeasurementAndTraceability);